import i18n from "@/i18n";
import Store from "@/store";

const SNACKBAR_DEFAULT_TIMEOUT = 4000;
const SNACKBAR_DEFAULT_ERROR_COLOR = "error";
const SNACKBAR_DEFAULT_SUCCESS_COLOR = "success";
const SNACKBAR_DEFAULT_INFO_COLOR = "info";
const SNACKBAR_DEFAULT_WARNING_COLOR = "warning";

function snackBarMapError(err) {
  let timeout = SNACKBAR_DEFAULT_TIMEOUT;
  let color = SNACKBAR_DEFAULT_ERROR_COLOR;
  let text = i18n.t("error-general");
  let code = undefined;
  if (err.response) {
    code = err.response.status;
    switch (err.response.status) {
      case 400:
        text = err.response.data;
        break;
      case 401:
      case 403:
      case 404:
      case 413:
        text = i18n.t(`error-${code}`);
        break;
      default:
        text = i18n.t("error-default");
        break;
    }
  }

  let payload = {
    timeout: timeout,
    color: color,
    message: text,
    code: code,
  };
  return payload;
}

function snackBarSuccessPayload(code, message) {
  let payload = {
    timeout: SNACKBAR_DEFAULT_TIMEOUT,
    color: SNACKBAR_DEFAULT_SUCCESS_COLOR,
    message: message,
    code: code,
  };
  return payload;
}

function showSnackbar(code, message, timeout, color) {
  let payload = {
    timeout: timeout,
    color: color,
    message: message,
    code: code,
  };
  Store.dispatch("snackbar/setSnackbar", payload);
}

function showSuccessSnackbar(
  code,
  message,
  timeout = SNACKBAR_DEFAULT_TIMEOUT
) {
  showSnackbar(code, message, timeout, SNACKBAR_DEFAULT_SUCCESS_COLOR);
}

function showErrorSnackbar(code, message, timeout = SNACKBAR_DEFAULT_TIMEOUT) {
  showSnackbar(code, message, timeout, SNACKBAR_DEFAULT_ERROR_COLOR);
}

function showWarningSnackbar(
  code,
  message,
  timeout = SNACKBAR_DEFAULT_TIMEOUT
) {
  showSnackbar(code, message, timeout, SNACKBAR_DEFAULT_WARNING_COLOR);
}

function showInfoSnackbar(code, message, timeout = SNACKBAR_DEFAULT_TIMEOUT) {
  showSnackbar(code, message, timeout, SNACKBAR_DEFAULT_INFO_COLOR);
}

export {
  snackBarSuccessPayload,
  snackBarMapError,
  showSuccessSnackbar,
  showErrorSnackbar,
  showWarningSnackbar,
  showInfoSnackbar,
};
